module.exports = __webpack_public_path__ + "static/art4-64b3df3c6697b6795124c20dfed5898b.png";